import {
    DeprecatedEllipsisIcon,
    DeprecatedExternalLinkIcon,
    IconButton,
    Menu,
    MenuItem,
    MenuList,
} from '@lokalise/louis';

import { DangerMenuItem, IconMenuItem } from './style';

type ActionMenuButtonProps = {
    onDelete: () => void;
    onOpen: () => void;
    onEdit: () => void;
    withSummary?: boolean;
};

const ActionMenuButton = ({ withSummary, onDelete, onOpen, onEdit }: ActionMenuButtonProps) => (
    <Menu
        menuButton={({ opened }) => (
            <IconButton active={opened} appearance="secondary" ariaLabel="Style guide actions">
                <DeprecatedEllipsisIcon />
            </IconButton>
        )}
    >
        <MenuList placement="left-start">
            <IconMenuItem onClick={onOpen}>
                Open file <DeprecatedExternalLinkIcon />
            </IconMenuItem>

            {withSummary && <MenuItem onClick={onEdit}>Edit AI summary</MenuItem>}
            <DangerMenuItem onClick={onDelete}>Delete</DangerMenuItem>
        </MenuList>
    </Menu>
);

export default ActionMenuButton;
